import useCartItemDeliveries from './hooks/useCartItemDeliveries'
import useSummaryData from './hooks/useSummaryData'
import useTranslation from 'hooks/useTranslation'
import Skeleton from 'react-loading-skeleton'
import { useParams } from 'react-router-dom'
import { displayPrice } from 'utils/string'
import React, { Fragment } from 'react'
import Schedule from './Schedule'
import './style.scss'

const Summary: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  const data = useSummaryData(id)
  const cartItemDeliveries = useCartItemDeliveries(id)
  let deliveryPrice = 0

  const { t } = useTranslation('basket')

  return (
    <>
      <div className='title'>
        <div>
          <span>{t('summary')}</span>
        </div>
      </div>

      {data?.now
        ? <div className='orderInfo__summary'>
          <div className='orderInfo__summary__header'>{t('feesNow')}</div>
          <div className='orderInfo__summary__content'>
            {data?.now?.list?.map(({ text, price, type, depositAmount }, idx) => {
              return <Fragment key={idx}>
                <div className={`orderInfo__summary__content__item --${type}`}>
                  <span>{text}:</span>
                  <span>{displayPrice(depositAmount ? (Number(price) - Number(depositAmount)) : price)}</span>
                </div>
                {depositAmount && <div className='orderInfo__summary__content__item'>
                  <span>{t('deposit')}:</span>
                  <span>{displayPrice(depositAmount)}</span>
                </div>}
              </Fragment>
            })}
            {(cartItemDeliveries?.itemsWithPrice as any[])?.map(item => {
              const price = Number(data.deliveries?.deliveries?.[item.externalDeliveryId]?.grossPrice || 0)
              deliveryPrice += price
              return <div
                key={item.identifier}
                className='orderInfo__summary__content__item --delivery'>
                <span>{t('delivery')}{cartItemDeliveries?.data?.[item.deliveryId]?.type ? ` (${t(cartItemDeliveries?.data?.[item.deliveryId]?.type)})` : ''}:</span>
                <span>{displayPrice(price || 0)}</span>
              </div>
            })}
          </div>
          <div className='orderInfo__summary__sum'>
            <span>{t('total')}:</span>
            <span>{displayPrice(data?.now?.price_sum ? Number(data?.now?.price_sum) + deliveryPrice : 0)}</span>
          </div>
        </div>
        : <div className='orderInfo__summary'>
          <div className='orderInfo__summary__header'>{t('feesNow')}</div>
          <div className='orderInfo__summary__content'>
            <Skeleton />
            <Skeleton />
          </div>
        </div>}

      {data?.monthly && data?.monthly?.length > 0 && <div className='orderInfo__summary'>
        <div className='orderInfo__summary__header'>{t('paymentSchedule')}</div>
        <Schedule schedule={data?.monthly} />
      </div>}

      {cartItemDeliveries?.deliveries && cartItemDeliveries.deliveries.length > 0 && <div className='orderInfo__summary'>
        <div className='orderInfo__summary__content'>
          {cartItemDeliveries.deliveries.map((delivery) => <Fragment key={delivery.id}>
            <div className='orderInfo__summary__content__item'>
              <span><b>{t(delivery?.type)}:</b></span>
              {(delivery.pointId || delivery.address) && <span>{delivery.pointId
                ? `${delivery.pointId}${delivery.lockerId ? `, ${t('locker')} ${delivery.lockerId}` : ''}`
                : delivery.address
                  ? `${delivery.address.street} ${delivery.address.estateNumber}${delivery.address.localNumber ? `/${delivery.address.localNumber}` : ''}, ${delivery.address.zip} ${delivery.address.city}`
                  : ''}
              </span>}
            </div>
            {(delivery.products as basic.Form[]).map((product) => <div
              key={product.identifier}
              className='orderInfo__summary__content__item'>
              <span>- {product.name}</span>
            </div>)}
          </Fragment>)}
        </div>
      </div>}
    </>
  )
}

export default Summary